const zIndex = {
  header: 10,
  content: 1,
  behindContent: -1,
  contentLayer: 20,
};

export default zIndex;
